import { useEffect, DependencyList, EffectCallback } from "react";

export const useEffectDangerous = (
  effect: EffectCallback,
  deps: DependencyList = []
): void => {
  //eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(effect, [...deps]);
};
